import React, { useEffect } from 'react'
import SubFooter from '../components/Footer/SubFooter'
import { Link } from 'react-router-dom';
import PulsaticTripAdvisor from '../components/Tours/PulsaticTripAdvisor';

function AboutScreen() {
  useEffect(() => {
    document.title = 'About Us | Stephenson Adventures';
  },[]);

  return (
    <div className="standard-ountline">
        <div className="standard-area">
          <div className="container">
          <div class="pdleft30 mgbot30" >
            <p>South Africa is filled to the brim with culture and music; wide-open spaces and bustling cities; 
              spectacular wildlife and welcoming people.&nbsp; 
              The best way to experience the wonders of the Rainbow Nation is with a knowledgeable guide who is passionate about the 
              areas you want to explore.
            </p>
            <h3><strong><em>“</em>
             <b>Stephenson Adventures strives to enrich the lives of our clients through sharing the inspiring history and breath-taking beauty of South Africa.&nbsp; It is our hope that by creating memorable experiences, we’ll grow to understand and love each other as a global family.</b>”</strong></h3>
            <p>Whether you’re visiting from abroad, searching for the famous highlights, or you’re a South African looking to discover hidden gems in the country you call home, the Stephenson Adventures team of charismatic, professional guides offers flexible, immersive experiences across the country.</p>
            <p>We love South Africa and we have been revealing her secrets to travellers from all over the world one intimate, private tour at a time since 2015.</p>
            <p><strong><em>Proud partner with Safari Bookings, for reviews and feedback you can visit</em></strong> 
            <Link to="https://www.safaribookings.com" target="_blank" >www.safaribookings.com</Link>        
            </p>
            </div>
          </div>
        </div>
        <PulsaticTripAdvisor />
      <SubFooter />   
    </div>
  )
}

export default AboutScreen